// Chat-thread entry to the contract wizard. Renders the V2
// ContractCreatePage in embedded mode inside a modal so the user stays
// on the Messages page — closing the modal keeps their place in the
// conversation. Must be rendered inside a ContractsProvider.

import React from 'react';
import { X } from 'lucide-react';
import { ContractsProvider } from '../../pages/Contracts/ContractsContext';
import ContractCreatePage, { ContractCreatePrefill } from '../../pages/Contracts/ContractCreatePage';

interface CreateContractModalProps {
  isOpen: boolean;
  onClose: () => void;
  prefill?: ContractCreatePrefill;
  // Called with the new contract id after a successful create.
  onCreated?: (contractId: string) => void;
}

export const CreateContractModal: React.FC<CreateContractModalProps> = ({ isOpen, onClose, prefill, onCreated }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-start justify-center bg-black/50 overflow-y-auto py-8 px-4">
      <div className="relative w-full max-w-3xl my-auto">
        <button
          onClick={onClose}
          className="absolute -top-2 right-0 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white text-gray-500 shadow hover:text-gray-900"
          aria-label="关闭"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="rounded-2xl bg-[#FDFDFD] p-6 shadow-2xl">
          <h2 className="text-xl font-semibold text-slate-900 mb-4">发起合同</h2>
          <ContractsProvider>
            <ContractCreatePage
              embedded
              prefill={prefill}
              onCreated={onCreated}
              onClose={onClose}
            />
          </ContractsProvider>
        </div>
      </div>
    </div>
  );
};
